<template>
  <b-modal
    id="modal-komchat-coin-remaining"
    hide-header
    hide-footer
    centered
  >
    <div class=" text-center">
      <div class="border border-[#E5E5E5] rounded-xl bg-[#FAFAFA] mt-1 py-1 mb-2">
        <div class="text-[#6B7280] text-sm mb-1">
          Komchat Coin Saat Ini
        </div>
        <div class="font-bold text-3xl text-[#1F2937]">
          {{ IDR(balance) }}
        </div>
      </div>

      <div class="mb-2">
        <span
          v-if="type === 'warning'"
          class="bg-[#FFF4E5] text-[#F97316] px-4 py-[6px] rounded-full text-xs font-semibold"
        >
          Tersisa {{ closingCount }} Closing Lagi
        </span>
        <span
          v-else-if="type === 'insufficient'"
          class="bg-[#FEE2E2] text-[#EF4444] px-4 py-[6px] rounded-full text-xs font-semibold"
        >
          Coin Tidak Mencukupi
        </span>
      </div>

      <div class="text-[14px] text-[#4B5563] mb-3 px-1 leading-relaxed">
        <span v-if="type === 'warning'">
          Saldo Komchat Coin kamu tersisa {{ IDR(balance) }}.
          <span
            class="font-bold text-[#1F2937] underline cursor-pointer"
            @click="$emit('topup')"
          >Top Up</span>
          sekarang agar closing order tetap lancar dan order berikutnya tidak terlewat!
        </span>
        <span v-else-if="type === 'insufficient'">
          Saldo minimal Komchat Coin <span class="font-bold text-[#1F2937]">Rp10.000</span> untuk buat Customer Service AI.
          <span
            class="font-bold text-[#1F2937] underline cursor-pointer"
            @click="$emit('topup')"
          >Top Up</span>
          sekarang agar fitur Customer Service AI bisa segera digunakan.
        </span>
      </div>

      <div v-if="type === 'warning'">
        <b-button
          variant="primary"
          block
          class="w-full !rounded-lg"
          @click="$emit('lanjut'); $bvModal.hide('modal-komchat-coin-remaining')"
        >
          Lanjut
        </b-button>
      </div>
      <div
        v-else-if="type === 'insufficient'"
        class="flex gap-3"
      >
        <b-button
          variant="outline-primary"
          class="w-1/2 !rounded-lg"
          @click="$emit('kembali'); $bvModal.hide('modal-komchat-coin-remaining')"
        >
          Kembali
        </b-button>
        <b-button
          variant="primary"
          class="w-1/2 !rounded-lg"
          @click="$emit('topup')"
        >
          Top Up
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { IDR } from '@/libs/currency'

export default {
  name: 'ModalKomchatCoinRemaining',
  props: {
    balance: {
      type: Number,
      required: true,
      default: 0,
    },
    type: {
      type: String,
      required: true,
      default: 'warning', // 'warning' or 'insufficient'
      validator: value => ['warning', 'insufficient'].includes(value),
    },
    closingCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      IDR,
    }
  },
}
</script>
